
  import { IBlog } from "@/interfaces";
  import { Component, Vue, Prop } from "vue-property-decorator";

  @Component
  export default class BlogCard extends Vue {
    @Prop({ required: true }) public blog!: IBlog;
  }
